<template lang="pug">
  v-card(color="grey lighten-4")
    v-card-text
      v-progress-circular.pl-5(color="primary" :indeterminate="true" v-if="loading")
      template(v-for="(item, index) in comments" v-else)
        v-layout(column)
          v-container(grid-list-lg)
            v-layout(row)
              v-avatar(size='25px')
                img(v-if="item.User && item.User.imageUrl" :src='item.User.imageUrl' alt='User')
                img(v-else src='../../../assets/images/user.jpeg', alt='User')
              v-flex.ml-2
                v-layout(column)
                  div
                    span.body-2.font-weight-medium {{ item.User.fullName }}
                    span.ml-1.body-1.grey--text {{ item.createDateTime | moment("from", "now") }}
                  div.font-weight-regular
                    span {{ item.comment }}

</template>

<script>
import commentService from '../service.js'
import { mapGetters } from 'vuex';

export default {
  props: ['commentID'],
  data() {
    return {
      comments: [],
      loading: true,      
    }
  },
  async created() {
    await this.getReply()
  },
  methods: {
    getReply() {
      console.log("this.commentID", this.commentID)
      return commentService
      .getCommentReply(this.commentID)
      .then((response) => {
        this.comments = response.data
        this.loading = false
        return response
      })
    }
  }
}
</script>

<style scoped>
</style>